import { ModalOptions } from 'ngx-bootstrap/modal';
import { NotificationType } from '@shared/models';

export type ComponentContext<T, N = void> = T & {
  onAction(value: N): void;
  onClose(): void;
};
export interface Options<T> {
  modalOptions?: ModalOptions;
  componentData?: T;
}

export interface ConfirmationOptions {
  title: string;
  message: string | string[];
  confirmButton: string;
  cancelButton: string;
}

export interface NotificationInfo {
  title: string;
  description: string;
  type: NotificationType;
}

export const defaultModalOptions: ModalOptions = {
  backdrop: 'static',
  keyboard: false,
  class: `modal-dialog-scrollable`
};

export const confirmDefaults: ConfirmationOptions = {
  title: 'common.titles.unsaved_changes',
  message: 'common.messages.unsaved_changes',
  confirmButton: 'common.buttons.confirm',
  cancelButton: 'common.buttons.cancel'
};
